export default __webpack_public_path__ + "static/media/0.476a44e4.png";